export interface ParameterConfig {
  // 入参类型 0:文字 1:图片
  input_parameter_type: number;
}

export enum ItemType {
  /** 入参类型 */
  InputParameter = 17,
}